<div class="pt-3 pb-2">
    <div class="col d-flex justify-content-center">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                {{'AS-OF-DATE' | translate}}
            </span>
            <kendo-datepicker class="w-50" [max]="maxDate" [(ngModel)]="asOfDate" [required]="true"
                (valueChange)="onAsOfDateChange($event)">
            </kendo-datepicker>
        </label>
    </div>
</div>
<div class="pl-3 pr-3 pb-4">
    <app-accumulator-grid [dataView]="viewAccumulators" [newTitleKey]="'USED-TOTAL'" [durationLoaded]="durationLoaded"
        [groupableServices]="true">
    </app-accumulator-grid>
</div>